import React from 'react';

function RealtimeQuestionsDisplay({ questions, isProcessing, isUpdating }) {
  return (
    <div className="card">
      {isUpdating && <div className="updating-bar questions" />}
      <h2>Anamnesefragen</h2>
      {isProcessing ? (
        <div className="loading">Fragen werden generiert...</div>
      ) : questions && questions.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {questions.map((item, index) => (
            <div key={index} style={{
              padding: '12px',
              background: index === 0 ? '#f5f3ff' : '#f9fafb',
              borderRadius: '8px',
              borderLeft: `3px solid ${index === 0 ? '#7c3aed' : index === 1 ? '#0891b2' : '#059669'}`
            }}>
              <div style={{
                fontSize: '13px',
                fontWeight: 700,
                color: index === 0 ? '#7c3aed' : index === 1 ? '#0891b2' : '#059669',
                marginBottom: '6px'
              }}>
                {item.diagnosis}
              </div>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {item.questions.map((q, i) => (
                  <li key={i} style={{
                    fontSize: '13px',
                    color: '#374151',
                    lineHeight: '1.5',
                    padding: '2px 0 2px 12px',
                    position: 'relative'
                  }}>
                    <span style={{
                      position: 'absolute',
                      left: 0,
                      top: '8px',
                      width: '4px',
                      height: '4px',
                      borderRadius: '50%',
                      background: '#9ca3af',
                      display: 'inline-block'
                    }} />
                    {q}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ color: '#9ca3af', fontSize: '14px' }}>
          Anamnesefragen werden während der Aufnahme automatisch generiert.
        </div>
      )}
    </div>
  );
}

export default RealtimeQuestionsDisplay;
